import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
// import { RouterModule } from '@angular/router';
import { Router } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';
import { TravelerComponent } from '../traveler/traveler.component';

@Component({
  selector: 'app-send-msg',
  templateUrl: './send-msg.component.html',
  styleUrls: ['./send-msg.component.css']
})
export class SendMsgComponent implements OnInit {

  public menu_item_id = '';
  public add_auth;
  public edit_auth;
  public del_auth;
  
  private dp = [];
  displayedColumns = ['chx_select', 'sr', 'acct_number', 'customer_name', 'national_id', 'mobile', 
    'passport_no'];
  // displayedColumns2 = ['acct_number', 'customer_name', 'national_id', 'mobile', 'passport_no'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<TravelerComponent>;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = {
    'table_name': 'customer', 'customer_name': '', 'acct_number': '', 'mobile': '', 'msg': '',
    'phone1': '', 'tax_no': '', 'national_id': '', 'passport_no': '', 'branch_id': '-1', 
    'title': 'قائمة المسافرين'
  };
  branchList = [];
  condition = '';
  rec_limit = 100;
  page_num = 0;
  page_index = 0;

  saveClicked = false;

  Traveler_List; Success_Msg; Error_Msg; Del_Msg;
  No_Traveler_Msg; WA_Msg_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, private router: Router,
    public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Traveler_List').subscribe((res: string) => {
      this.Traveler_List = res;
    });
    this.model['title'] = this.Traveler_List;

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });
    
    translate.get('No_Traveler_Msg').subscribe((res: string) => {
      this.No_Traveler_Msg = res;
    });
    
    translate.get('WA_Msg_Msg').subscribe((res: string) => {
      this.WA_Msg_Msg = res;
    });
  }

  ngOnInit() {
    let href = this.router.url;
    let urlParts = href.split("/");
    if (urlParts[2] == '8') {
      this.menu_item_id = '116';
    }
    else if (urlParts[2] == '13') {
      this.menu_item_id = '117';
    }

    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];
        this.branchList.push({ 'branch_id': '0', 'branch_name': 'مشترك لجميع الفروع', 
          'branch_name_en': 'Common to all branches' });
        
        this.branchList.unshift({ 'branch_id': '-1', 'branch_name': 'الكل', 'branch_name_en': 'All' });
      });
  }

  search() {

    this.condition = "";

    if (this.model['customer_name'] != '')
      this.condition = " AND (`customer`.`customer_name` LIKE '%" + this.model['customer_name'] +
        "%' OR `customer`.`customer_name_en` LIKE '%" + this.model['customer_name'] + "%')";

    if (this.model['mobile'] != '')
      this.condition += " AND `customer`.`mobile` LIKE '%" + this.model['mobile'] + "%'";

    if (this.model['phone1'] != '')
      this.condition += " AND (`customer`.`phone1` LIKE '%" + this.model['phone1'] + "%' OR `customer`.`phone2` LIKE '%" + this.model['phone1'] + "%')";

    if (this.menu_item_id == '116') {
      if (this.model['acct_number'] != '')
        this.condition += " AND `customer`.`acct_number` LIKE '%" + this.model['acct_number'] + "%'";

      if (this.model['tax_no'] != '')
        this.condition += " AND `customer`.`tax_no` LIKE '%" + this.model['tax_no'] + "%'";
    }
    else if (this.menu_item_id == '117') {
      if (this.model['national_id'] != '')
        this.condition += " AND `customer`.`national_id` LIKE '%" + this.model['national_id'] + "%'";

      if (this.model['passport_no'] != '')
        this.condition += " AND `traveler_info`.`passport_no` LIKE '%" + this.model['passport_no'] + "%'";
    }

    if (this.model['branch_id'] != '-1')
      this.condition += " AND `customer`.`branch_id` = '" + this.model['branch_id'] + "'";

    else if (this.model['branch_id'] == '-1') {
      let index = 1;
      let list_length = this.branchList.length;

      this.condition += " AND `customer`.`branch_id` IN (";
      this.branchList.forEach(element => {
        if (element.branch_id != '-1') {
          if (index < list_length)
            this.condition += " '" + element.branch_id + "',";
          else if (index == list_length)
            this.condition += " '" + element.branch_id + "'";
        }
        index++;
      });
      this.condition += ")";
    }

    let query = "";
    if (this.menu_item_id == '116') {

      query = "SELECT COUNT(`customer`.`customer_id`) AS `count` FROM `customer` WHERE `customer`.`status` = '1'" + 
        this.condition;
    }
    else if (this.menu_item_id == '117') {

      query = "SELECT COUNT(`customer`.`customer_id`) AS `count` FROM `customer`, `traveler_info` WHERE " + 
        "`customer`.`acct_number` = `traveler_info`.`acct_number`" + this.condition + 
        " AND `customer`.`status` = '1'";
    }

    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        
        let result = data.data['list'][0]['count'];
        this.page_num = Math.ceil(result / this.rec_limit);
        this.page_index = 0;
        this.getSearchList(this.page_index);

        (document.getElementById('chx_select_all') as HTMLInputElement).checked = false;
      });
  }
  
  getSearchList(page_index) {
    let offset = 0;
    this.page_index = page_index;
    
    if (page_index > 0) {
      offset = page_index * this.rec_limit;
    }

    let query = "";
    if (this.menu_item_id == '116') {

      query = "SELECT `customer`.* FROM `customer` WHERE `customer`.`status` = '1'" + this.condition;
    }
    else if (this.menu_item_id == '117') {

      query = "SELECT `customer`.*, `traveler_info`.*, `city`.`city_name`, `country`.`country_id`" +
        " FROM `customer`, `traveler_info`, `city`, `country` WHERE `customer`.`acct_number` = `traveler_info`.`acct_number`"
        + this.condition + " AND `customer`.`city_id` = `city`.`city_id` AND `city`.`country_id` = `country`.`country_id`" +
        " AND `customer`.`status` = '1'";
    }
    query += " LIMIT " + offset + ", " + this.rec_limit; 

    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        let sr_no = 1;
        this.dp = data.data['list'];
        this.dp.forEach(element => {
          element.sr = sr_no;
          sr_no++;
        });

        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  print() {
    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="33%"> ' + this.Traveler_List + ' </td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('customer_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

  selectAll() {
    var selectAllInput = document.getElementById('chx_select_all') as HTMLInputElement;
    
    this.dp.forEach(element => {
      (document.getElementById('chx_select_' + element.acct_number) as HTMLInputElement).checked = selectAllInput.checked;
    });
  }

  sendLink() {
    let obj = { cmd: 'sendWAContLink', to: '0560581881', cont_url: 'https://alaqeela.com/acct/acct_ws/contract_print.php?invoice_no=1-2024-978&lang=ar' };
    console.log(obj);
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        if (data.status['type'] == 'success') 
          alert(this.Success_Msg);
        else 
          alert(this.Error_Msg);
      });
  }

  sendWA() {
    this.saveClicked = true;
    let to = "";
      
    this.dp.forEach(element => {
      if ((document.getElementById('chx_select_' + element.acct_number) as HTMLInputElement).checked) {
        if (to != "")
          to += ",";

        to += element.mobile;
      }
    });

    if (to == "") {
      alert(this.No_Traveler_Msg);
      this.saveClicked = false;
      return;
    }

    if (this.model['msg'] == "") {
      alert(this.WA_Msg_Msg);
      this.saveClicked = false;
      return;
    }

    let obj = { cmd: 'sendWA', to: to, msg_body: this.model.msg };
    console.log(obj);
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        if (data.status['type'] == 'success') 
          alert(this.Success_Msg);
        else 
          alert(this.Error_Msg);
      });
  }

}
